import React, { useEffect, useState } from "react";
import className from "classnames";
import uniqueId from "lodash.uniqueid";
import { Plan, StarRating as StarRatingType } from "../../../@types";
import { OriginalMedicareStarRatings, StarRating } from "../../../components";

export interface StarRatingRowProps {
  color?: string;
  label?: string;
  starRating?: StarRatingType;
  onClick: () => void;
  open: boolean;
  showOriginalMedicareStars?: boolean;
  plan: Plan;
  ariaLabel?: string;
}

const StarRatingRow: React.FunctionComponent<StarRatingRowProps> = props => {
  let stars = null;
  const color = props.color || "white";
  const [containerId, setContainerId] = useState("");

  if (typeof props.starRating !== "undefined") {
    stars = (
      <StarRating
        stars={props.starRating}
        includeLabel={false}
        planYear={props.plan.contract_year}
      />
    );
  }

  useEffect(() => {
    setContainerId(uniqueId("star_ratings_container_"));
  }, []);

  return (
    <div className="StarRatingExpandableRow">
      <button
        className={`StarRatingExpandableRow__toggle StarRatingExpandableRow__toggle__${color}`}
        data-testid="rating-row-button"
        onClick={props.onClick}
        aria-expanded={props.open}
        aria-controls={containerId}
      >
        <div className="ds-u-display--flex mct-u-width--full">
          <i
            className={className(
              "ds-u-margin-right--1",
              { "fas fa-plus ": !props.open },
              { "fas fa-minus": props.open }
            )}
          />
          <div className="ds-u-display--flex ds-u-flex-wrap--wrap ds-u-md-flex-wrap--nowrap ds-u-justify-content--between mct-u-width--full">
            <h3
              data-testid="rating-row-label"
              className={"StarRatingsSection__heading"}
              aria-label={props.ariaLabel}
            >
              {props.label}
            </h3>
            {stars}
          </div>
        </div>
      </button>
      {props.open && props.showOriginalMedicareStars && (
        <div className="StarRatingRow">
          <OriginalMedicareStarRatings plan={props.plan} />
        </div>
      )}
      {props.open && (
        <div id={containerId} data-testid="row-children">
          {props.children}
        </div>
      )}
    </div>
  );
};

export default StarRatingRow;
